import {ModalDialog} from '../ModalDialog';
import {MatDialog} from '@angular/material';
import {ConfigInterface} from './ConfigInterface';
import {ComponentType} from '@angular/cdk/portal';
import {Injectable, TemplateRef} from '@angular/core';

@Injectable()
export class Factory {

    private matDialog: MatDialog = null;

    private modalConfig: ConfigInterface = null;

    // ########################################

    constructor(
        matDialog: MatDialog
    ) {
        this.matDialog = matDialog;

        this.modalConfig = {
            panelClass: 'default-modal-style',
            backdropClass: 'default-modal-backdrop-style',
            maxWidth: '80vw',
            maxHeight: '80vw',
            height: '60%',
            width: '60%',
            autoFocus: true,
            closeOnNavigation: true
        };
    }

    // ########################################

    public create(componentOrTemplateRef: ComponentType<any> | TemplateRef<any>): ModalDialog {
        return new ModalDialog(this.matDialog, componentOrTemplateRef, this.modalConfig);
    }

    // ########################################
}
